var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { TextVariants, Label2, Colors } from "../../index";
export const UserInputStack = ({ id, children }) => {
    return (_jsx(Flex, { sx: {
            flexDirection: "column",
            width: "100%",
            borderLeft: "1px solid",
            borderTop: "1px solid",
            borderRight: "1px solid",
            borderColor: `${Colors.grey}.3`
        }, id: id, children: children }));
};
export const UserInputStackLineItem = (_a) => {
    var { children, sx = {} } = _a, props = __rest(_a, ["children", "sx"]);
    return (_jsx(Box, Object.assign({ sx: Object.assign(Object.assign({}, sx), { paddingTop: 16, paddingLeft: 16, paddingRight: 16, paddingBottom: 16, borderBottom: "1px solid", borderColor: `${Colors.grey}.3`, flex: 1, variant: `text.${TextVariants.technicalParagraphSmall}` }) }, props, { children: children })));
};
export const UserInputTitleCard = ({ title, children }) => {
    return (_jsxs(UserInputStackLineItem, { children: [_jsx(Flex, { sx: { alignItems: "center", marginBottom: 8 }, children: _jsx(Box, { children: _jsx(Label2, { sx: { color: `${Colors.grey}.1` }, children: title }) }) }), _jsx(Box, { sx: {
                    color: `${Colors.black}.1`,
                    variant: `text.${TextVariants.technicalParagraphSmall}`
                }, children: children })] }));
};
/*
  Provides a line item with a link that relates to the line items
*/
export const UserInputCard = ({ title, changeLink, children }) => {
    return (_jsxs(UserInputStackLineItem, { children: [_jsxs(Flex, { sx: { alignItems: "center", marginBottom: 8 }, children: [_jsx(Box, { children: _jsx(Label2, { sx: { color: `${Colors.grey}.1` }, children: title }) }), _jsx(Box, { sx: { flex: 1, textAlign: "right" }, children: _jsx(Label2, { sx: { a: { textDecoration: "none", color: `${Colors.blue}.0` } }, children: changeLink }) })] }), _jsx(Box, { sx: {
                    color: `${Colors.black}.1`,
                    variant: `text.${TextVariants.label2}`
                }, children: children })] }));
};
//# sourceMappingURL=UserInputStack.js.map